import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, unref as _unref, vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6 bg-white dark:bg-gray-900" }
const _hoisted_2 = { class: "mt-2 -space-y-px rounded-md shadow-sm" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = ["type"]
const _hoisted_5 = { class: "flex absolute inset-y-0 right-0" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = ["type"]
const _hoisted_8 = { class: "flex absolute inset-y-0 right-0" }
const _hoisted_9 = {
  id: "password-match-indicator",
  class: "pr-3 flex items-center pointer-events-none relative z-20"
}

import { 
		Auth
	} from 'aws-amplify'

	// components
	import {
		CheckCircleIcon
	} from '@heroicons/vue/24/outline'

	import {
		CheckCircleIcon as CheckCircleIconMini,
		EyeIcon as EyeIconMini,
		EyeSlashIcon as EyeSlashIconMini
	} from '@heroicons/vue/20/solid'

	// router
	import {
		useRouter
	} from 'vue-router'

	// store
	import { 
		store as _systemStore
	} from '@/store/system'

	import { 
		store as _userStore
	} from '@/store/user'

	// vue
	import {
		computed,
		ref
	} from 'vue'

	
	const __default__ = { name: 'PasswordExpiredForm' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// api
	const router = useRouter()

	const userStore = _userStore()
	const systemStore = _systemStore()
	
	const email = ref("")
	const currentPassword = ref("")
	const newPassword = ref("")
	const confirmNewPassword = ref("")
	const loading = ref(false)
	const inputEmail = ref<null | {valid: Boolean}>(null)
	const inputPassword = ref<null | {valid: Boolean}>(null)
	const inputNewPassword = ref<null | {valid: Boolean}>(null)
	const inputNewPasswordConfirm = ref<null | {valid: Boolean}>(null)
	const passwordConfirmMessage = ref("Please fill in your new password.")

	const showPassword = ref<boolean>(false)

	const passwordsMatch = computed(() => {
		return newPassword.value && (newPassword.value === confirmNewPassword.value)
	})

	async function updatePassword() {
		loading.value = true
		let formError = false
		if (newPassword.value != confirmNewPassword.value) {
			document.getElementById('verifyNewPassword')?.focus()
			passwordConfirmMessage.value = "New password does not match."
			if(inputNewPasswordConfirm.value)inputNewPasswordConfirm.value.valid = false
			formError = true
		}
		if (confirmNewPassword.value == "") {
			document.getElementById('verifyNewPassword')?.focus()
			if(inputNewPasswordConfirm.value)inputNewPasswordConfirm.value.valid = false
			formError = true
		}
		if (newPassword.value == "") {
			document.getElementById('newPassword')?.focus()
			if(inputNewPassword.value)inputNewPassword.value.valid = false
			formError = true
		}
		if (currentPassword.value == "") {
			document.getElementById('currentPassword')?.focus()
			if(inputPassword.value)inputPassword.value.valid = false
			formError = true
		}
		if (email.value == "") {
			document.getElementById('email')?.focus()
			if(inputEmail.value)inputEmail.value.valid = false
			formError = true
		}
		
		if(formError) {
			loading.value = false
			return
		}

		try {
			await Auth.completeNewPassword(userStore.user.cognitoUser, newPassword.value)
			const user = await Auth.signIn(email.value, newPassword.value)
			userStore.user.cognitoUser = user
			loading.value = false
			router.push({name: systemStore.system.primaryRoute})
		} 
		catch(e) {
			console.error(e)
			// do something with the error
		}
		finally {
			loading.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "-mt-8 mb-10 text-sm leading-6 text-gray-500 dark:text-gray-400" }, [
      _createElementVNode("p", null, [
        _createTextVNode(" You used an "),
        _createElementVNode("span", { class: "font-semibold dark:text-gray-300" }, "expired"),
        _createTextVNode(" or "),
        _createElementVNode("span", { class: "font-semibold dark:text-gray-300" }, "temporary"),
        _createTextVNode(" password. ")
      ]),
      _createElementVNode("p", null, " Please update your password below before continuing. ")
    ], -1)),
    _createElementVNode("form", {
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (updatePassword()), ["prevent"])),
      class: "space-y-6"
    }, [
      _createElementVNode("div", null, [
        _createVNode(_component_tw_input, {
          modelValue: email.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
          id: "email",
          required: true,
          type: "email",
          autocomplete: "email",
          label: "Email address",
          validation: "Please enter your email address."
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_tw_input, {
          modelValue: currentPassword.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPassword).value = $event)),
          id: "currentPassword",
          ref_key: "inputPassword",
          ref: inputPassword,
          required: true,
          type: "password",
          label: "Current password",
          validation: "Please fill in your current password."
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("fieldset", _hoisted_1, [
        _cache[8] || (_cache[8] = _createElementVNode("legend", { class: "block text-sm font-bold leading-6 text-gray-900 dark:text-gray-200" }, " New Password ", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              for: "password",
              class: "sr-only"
            }, "New password", -1)),
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newPassword).value = $event)),
                type: showPassword.value ? 'text' : 'password',
                name: "new-password",
                id: "password",
                autocomplete: "new-password",
                class: "pr-12 relative min-w-0 block w-full rounded-none rounded-t-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-dbBlue sm:text-sm sm:leading-6 dark:bg-white/5 dark:text-white dark:ring-white/10 dark:focus:ring-indigo-500",
                placeholder: "New password"
              }, null, 8, _hoisted_4), [
                [_vModelDynamic, newPassword.value]
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  id: "show-hide-password",
                  tabindex: "-1",
                  class: "pr-3 flex items-center text-gray-300 dark:text-gray-500 z-20",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showPassword.value = !showPassword.value), ["prevent"]))
                }, [
                  _withDirectives(_createVNode(_unref(EyeIconMini), {
                    class: "h-5 w-5",
                    "aria-hidden": "true",
                    tabindex: "-1"
                  }, null, 512), [
                    [_vShow, !showPassword.value]
                  ]),
                  _withDirectives(_createVNode(_unref(EyeSlashIconMini), {
                    class: "h-5 w-5",
                    "aria-hidden": "true",
                    tabindex: "-1"
                  }, null, 512), [
                    [_vShow, showPassword.value]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              for: "confirm-password",
              class: "sr-only"
            }, "Confirm new password", -1)),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((confirmNewPassword).value = $event)),
                type: showPassword.value ? 'text' : 'password',
                name: "confirm-password",
                id: "confirm-password",
                autocomplete: "new-password",
                class: "pr-12 relative min-w-0 block w-full rounded-none rounded-b-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-dbBlue sm:text-sm sm:leading-6 dark:bg-white/5 dark:text-white dark:ring-white/10 dark:focus:ring-indigo-500",
                placeholder: "Confirm new password"
              }, null, 8, _hoisted_7), [
                [_vModelDynamic, confirmNewPassword.value]
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(CheckCircleIconMini), {
                    class: _normalizeClass([{'opacity-0': !passwordsMatch.value}, "h-5 w-5 text-green-500 transition-all duration-300 ease-in-out absolute right-3"]),
                    "aria-hidden": "true"
                  }, null, 8, ["class"]),
                  _createVNode(_unref(CheckCircleIcon), {
                    class: _normalizeClass([{'opacity-0': passwordsMatch.value}, "h-5 w-5 text-gray-300 dark:text-gray-500 transition-all duration-300 ease-in-out absolute right-3"]),
                    "aria-hidden": "true"
                  }, null, 8, ["class"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_tw_button, {
          type: "submit",
          class: "btn-db-yellow w-full",
          disabled: loading.value,
          loading: loading.value
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode(" Continue ")
          ])),
          _: 1,
          __: [9]
        }, 8, ["disabled", "loading"])
      ])
    ], 32)
  ]))
}
}

})